import React, { useState, useEffect } from "react";
import Image1 from "../../images/banner1.2.webp";
import Image2 from "../../images/banner2.webp";
import Image3 from "../../images/banner3.webp";
import Image5 from "../../images/mbanner1.webp";
import Image6 from "../../images/mbanner2.webp";
import Image7 from "../../images/mbanner3.webp";

const desktopSlides = [
  { id: 1, image: Image1, alt: "BMRDA Approved Plots in Chikka Madure" },
  { id: 2, image: Image2, alt: "Gated Community Layouts" },
  { id: 3, image: Image3, alt: "Premium Land Investments" },
];

const mobileSlides = [
  { id: 5, image: Image5, alt: "BMRDA Approved Plots in Chikka Madure" },
  { id: 6, image: Image6, alt: "Premium Land Investments" },
  { id: 7, image: Image7, alt: "Gated Community Layouts" },
];

export default function HeaderCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Handle screen resizing
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const slides = isMobile ? mobileSlides : desktopSlides;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="relative md:mx-12 overflow-hidden mt-2 md:mt-2">
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide) => (
          <div key={slide.id} className="min-w-full">
            <img
              src={slide.image}
              alt={slide.alt}
              loading="lazy"
              className="w-full h-[400px] md:h-[500px] object-cover"
              title="Urban Nest Properties"
            />
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className="w-6 h-6 md:w-10 md:h-10 p-0 rounded-full flex items-center justify-center focus:outline-none"
            aria-label={`Go to slide ${index + 1}`}
          >
            <span
              className={`w-2.5 h-2.5 rounded-full transition-colors duration-300 ${
                index === currentIndex ? "bg-white" : "bg-white/50"
              }`}
            ></span>
          </button>
        ))}
      </div>
    </div>
  );
}
